console.log('🛒 Cart Script Loaded'); // This tells us the file is connected

// Function to format money
function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

// 1. Fetch and Render Cart
async function updateCartDrawer() {
  console.log('🔄 Updating Drawer...');
  const res = await fetch('/cart.js');
  const cart = await res.json();
  
  const itemsContainer = document.getElementById('drawer-items');
  const footerPrice = document.getElementById('drawer-subtotal-price');
  
  // Update Price
  footerPrice.innerText = formatMoney(cart.total_price);

  // Clear current items
  itemsContainer.innerHTML = '';

  if (cart.items.length === 0) {
    itemsContainer.innerHTML = '<p class="empty-cart-msg">Your cart is empty.</p>';
    return;
  }

  // Loop through items
  cart.items.forEach(item => {
    const html = `
      <div class="drawer-item">
        <img src="${item.image}" alt="${item.title}" class="item-image">
        <div class="item-details">
          <a href="${item.url}" class="item-title">${item.product_title}</a>
          <div class="item-price">${formatMoney(item.line_price)}</div>
          <div class="item-options" style="font-size:0.8rem; color:#666;">${item.variant_title !== 'Default Title' ? item.variant_title : ''}</div>
          <button class="item-remove" onclick="removeItem('${item.key}')">Remove</button>
        </div>
      </div>
    `;
    itemsContainer.innerHTML += html;
  });
}

// 2. Open/Close Logic
function openDrawer() {
  console.log('📂 Opening Drawer');
  const overlay = document.getElementById('cart-overlay');
  const drawer = document.getElementById('cart-drawer');
  
  if(overlay && drawer) {
    overlay.classList.add('active');
    drawer.classList.add('active');
    updateCartDrawer();
  } else {
    console.error('❌ Drawer elements not found in HTML');
  }
}

function closeDrawer() {
  const overlay = document.getElementById('cart-overlay');
  const drawer = document.getElementById('cart-drawer');
  if(overlay && drawer) {
    overlay.classList.remove('active');
    drawer.classList.remove('active');
  }
}

// 3. Remove Item Logic
async function removeItem(key) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  });
  updateCartDrawer();
}

// 4. Initialize Listeners
document.addEventListener('DOMContentLoaded', () => {
  // Close buttons
  const closeBtn = document.getElementById('close-drawer');
  const overlay = document.getElementById('cart-overlay');
  
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  // ROBUST SELECTOR: Find any form that POSTs to cart/add
  // We use [action*="/cart/add"] to match if it contains the string, tackling the query param issue
  const forms = document.querySelectorAll('form[action*="/cart/add"]');
  
  console.log(`🔎 Found ${forms.length} Add-to-Cart forms`);

  forms.forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault(); // STOP the redirect
      console.log('🛑 Form submit intercepted!');
      
      const submitBtn = form.querySelector('[type="submit"]');
      if(submitBtn) submitBtn.innerText = 'Adding...';
      
      const formData = new FormData(form);
      
      // Add to cart via AJAX
      await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });

      if(submitBtn) submitBtn.innerText = 'Add to Cart';

      // Open drawer
      openDrawer();
    });
  });
});